// TODO Currently works only with one tablist per page.
document.addEventListener("DOMContentLoaded", () => {
  const tablist = document.querySelector('[role="tablist"]');
  if (!tablist) return;

  const tabs = Array.from(
    tablist.querySelectorAll<HTMLElement>('[role="tab"]'),
  );
  const panels = Array.from(
    document.querySelectorAll<HTMLElement>('[role="tabpanel"]'),
  );
  const tabSwitchInput: HTMLInputElement | null = document.querySelector(
    "[data-tab-switch-input]",
  );

  function activateTab(tab: HTMLElement) {
    // Iterate through all tabs and deactivate them
    tabs.forEach((t) => {
      t.setAttribute("aria-selected", "false");
      t.setAttribute("tabindex", "-1");
      t.classList.remove(
        "bg-ui-base-base",
        "border",
        "border-ui-border-standard",
      );
      t.classList.add("text-ti-inverted-disabled");
    });

    const tabValue = tab.getAttribute("data-value");
    if (tabSwitchInput) tabSwitchInput.value = tabValue || "";

    // Activate the active tab
    tab.setAttribute("aria-selected", "true");
    tab.setAttribute("tabindex", "0");
    tab.classList.add("bg-ui-base-base", "border", "border-ui-border-standard");
    tab.classList.remove("text-ti-inverted-disabled");
    tab.focus();

    // Manage the panels
    const targetPanelId = tab.getAttribute("aria-controls");
    panels.forEach((panel) => {
      if (panel.id === targetPanelId) {
        panel.classList.remove("hidden");
        panel.classList.add("block");
      } else {
        panel.classList.add("hidden");
        panel.classList.remove("block");
      }
    });
  }

  // Click and keyboard navigation for tabs
  tabs.forEach((tab) => {
    tab.addEventListener("click", (event) => {
      event.preventDefault();
      activateTab(tab);
    });

    // Tastaturnavigation mit Pfeiltasten
    tab.addEventListener("keydown", (event) => {
      const index = tabs.indexOf(tab);
      if (event.key === "ArrowRight") {
        event.preventDefault();
        const next = tabs[(index + 1) % tabs.length] as HTMLElement;
        activateTab(next);
      } else if (event.key === "ArrowLeft") {
        event.preventDefault();
        const prev = tabs[
          (index - 1 + tabs.length) % tabs.length
        ] as HTMLElement;
        activateTab(prev);
      }
    });
  });
});
